export const heroImages = [
  '/hero/tables-band.jpg',
  '/hero/tables-disco.jpg',
  '/hero/tables-mezzanine.jpg',
  '/hero/tables-buffet.jpg',
  '/hero/crowd-overhead.jpg',
  '/hero/dance-floor.jpg',
  '/hero/couple-dance.jpg',
];
